var exports = {
  "o": "xaf9ae18d--52a3e1--legend",
};

module.exports = exports;
